import qs from 'qs'
import axios from '../config/axios.js'
import { getApiUrl } from '../config/baseUrl.js'
let config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' } };
let configV1 = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } };
let configV2 = { headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' } };
const BASE_URL = getApiUrl('/api/college_manage')
export const classServer = {
  classAdd: (params) => {
    return axios.post(`${BASE_URL}/grade/add`, params, {skipErrorHandling: true}, configV1).then(res => res.data)
  },
  classUpdate: (params) => {
    return axios.post(`${BASE_URL}/grade/update`, params, {skipErrorHandling: true}, configV1).then(res => res.data)
  },
  classCourseConfig: (params) => {
    return axios.post(`${BASE_URL}/grade/editCourseConfig`, qs.stringify(params), {skipErrorHandling: true}, config).then(res => res.data)
  },
  classNameList: (params) => {
    return axios.get(`${BASE_URL}/grade/queryGradeList`, {params: params}).then(res => res.data)
  },
  classStudentQuery: (params) => {
    return axios.get(`${BASE_URL}/grade/queryStudentList`, {params}).then(res => res.data)
  },
  classDetail: (params) => {
    return axios.get(`${BASE_URL}/grade/queryById`, {params: params}).then(res => res.data)
  },
  classStudentDetail: (params) => {
    return axios.post(`${BASE_URL}/grade/studentDetail`, qs.stringify(params), {skipErrorHandling: true}, config).then(res => res.data)
  },
  classSearchList: (params) => {
    return axios.get(`${BASE_URL}/grade/searchList`, {params: params}).then(res => res.data)
  },
  deleteGrade: (params) => {
    return axios.post(`${BASE_URL}/grade/deleteGrade`, qs.stringify(params), config).then(res => res.data)
  },
  deleteStudents: (params) => {
    return axios.post(`${BASE_URL}/grade/deleteStudents`, qs.stringify(params), config).then(res => res.data)
  }
}
export const studentServer = {
  studentAdd: (params) => {
    return axios.post(`${BASE_URL}/student/add`, params, {skipErrorHandling: true}, configV1).then(res => res.data)
  },
  studentUpdate: (params) => {
    return axios.post(`${BASE_URL}/student/update`, params, {skipErrorHandling: true}, configV1).then(res => res.data)
  },
  studentChangeClass: (params) => {
    return axios.post(`${BASE_URL}/student/changeGradeInfo`, qs.stringify(params), {skipErrorHandling: true}, config).then(res => res.data)
  },
  studentDetail: (params) => {
    return axios.get(`${BASE_URL}/student/queryStudentById`, {params: params}).then(res => res.data)
  },
  studentImport: (params) => {
    return axios.post(`${BASE_URL}/student/importUser`, params, configV2).then(res => res.data)
  },
  studentResetPassword: (params) => {
    return axios.post(`${BASE_URL}/student/resetPassword`, qs.stringify(params), {skipErrorHandling: true}, config).then(res => res.data)
  }
}
export const classAnalysisServer = {
  queryGradeByProfessionId: (params) => {
    return axios.get(`${BASE_URL}/gradeAnalysis/queryGradeByProfessionId`, {params: params}).then(res => res.data)
  },
  queryGradeDirectoryById: (params) => {
    return axios.get(`${BASE_URL}/gradeAnalysis/queryGradeDirectoryById`, {params: params}).then(res => res.data)
  },
  queryGradeStudentRankList: (params) => {
    return axios.get(`${BASE_URL}/gradeAnalysis/queryGradeStudentRankList`, {params: params}).then(res => res.data)
  },
  queryGradeChapterList: (params) => {
    return axios.get(`${BASE_URL}/gradeAnalysis/queryGradeChapterList`, {params: params}).then(res => res.data)
  },
  queryQuestionList: (params) => {
    return axios.get(`${BASE_URL}/gradeAnalysis/queryQuestionList`, {params: params}).then(res => res.data)
  },
  queryStudyList: (params) => {
    return axios.get(`${BASE_URL}/gradeAnalysis/queryStudyList`, {params: params}).then(res => res.data)
  },
  queryGradeComparisonList: (params) => {
    return axios.get(`${BASE_URL}/gradeAnalysis/queryGradeComparisonList`, {params: params}).then(res => res.data)
  },
  queryQuestionDetail: (params) => {
    return axios.get(`${BASE_URL}/gradeAnalysis/queryQuestionDetail`, {params: params}).then(res => res.data)
  },
  queryStudyDetail: (params) => {
    return axios.get(`${BASE_URL}/gradeAnalysis/queryStudyDetail`, {params: params}).then(res => res.data)
  },
}
export const studentCenterServer = {
  queryPlatformStudentList: (params) => {
    return axios.get(`${BASE_URL}/student/queryPlatformStudentList`, {params: params}).then(res => res.data)
  },
  studentAnalysisChapterList: (params) => {
    return axios.get(`${BASE_URL}/student/studentAnalysisChapterList`, {params: params}).then(res => res.data)
  },
  studentAnalysisDetail: (params) => {
    return axios.get(`${BASE_URL}/student/studentAnalysisDetail`, {params: params}).then(res => res.data)
  }
}


// WEBPACK FOOTER //
// ./src/api/server/class.js